import { useEffect, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  deleteDoc,
  addDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../../firebase";

export default function AdminDashboard() {
  const [registros, setRegistros] = useState([]);
  const [selecionado, setSelecionado] = useState(null);
  const [form, setForm] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState(null);

  const currentUser = JSON.parse(localStorage.getItem("user"));
  const isAdmin = currentUser?.email === "fernando@telesca.com.br";

  useEffect(() => {
    if (isAdmin) {
      const fetchData = async () => {
        const snap = await getDocs(collection(db, "bolao"));
        setRegistros(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      };
      fetchData();
    }
  }, [isAdmin]);

  const handleSelect = (registro) => {
    setSelecionado(registro.id);
    setForm({
      ...registro,
      numerosSorteados: registro.numerosSorteados || [],
      // Inicializa apostas como um array vazio se não existir
      apostas: registro.apostas || [{ numerosAposta: [], valorAposta: 0 }],
    });
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleParticipantChange = (index, field, value) => {
    const updated = [...form.participantes];
    updated[index][field] = value;
    setForm((prev) => ({ ...prev, participantes: updated }));
  };

  const handleAddParticipant = () => {
    const novoParticipante = { nome: "", cotas: 0, comprovanteUrl: "" };
    setForm((prev) => ({
      ...prev,
      participantes: [...prev.participantes, novoParticipante],
    }));
  };

  const handleRemoveParticipant = (index) => {
    const updated = [...form.participantes];
    updated.splice(index, 1);
    setForm((prev) => ({ ...prev, participantes: updated }));
  };

  const handleComprovanteUpload = async (index, file) => {
    const path = `comprovantes/${form.id}/participante_${index}_${file.name}`;
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    const updated = [...form.participantes];
    updated[index].comprovanteUrl = url;
    setForm((prev) => ({ ...prev, participantes: updated }));
    alert("Comprovante enviado.");
  };

  // Funções para lidar com as apostas
  const handleApostaChange = (apostaIndex, field, value) => {
    const updatedApostas = [...form.apostas];
    if (field === "numerosAposta") {
      // Assuming value is a string of numbers separated by comma or space
      // Convert string to array of numbers
      updatedApostas[apostaIndex][field] = value
        .split(/[\s,]+/)
        .map(Number)
        .filter((num) => !isNaN(num) && num > 0);
    } else {
      updatedApostas[apostaIndex][field] = value;
    }
    setForm((prev) => ({ ...prev, apostas: updatedApostas }));
  };

  const handleAddAposta = () => {
    setForm((prev) => ({
      ...prev,
      apostas: [...prev.apostas, { numerosAposta: [], valorAposta: 0 }],
    }));
  };

  const handleRemoveAposta = (apostaIndex) => {
    const updatedApostas = [...form.apostas];
    updatedApostas.splice(apostaIndex, 1);
    setForm((prev) => ({ ...prev, apostas: updatedApostas }));
  };

  const handleSave = async () => {
    if (form.id) {
      const { id, ...data } = form;
      await updateDoc(doc(db, "bolao", id), data);
      alert("Registro atualizado.");
      setRegistros((prev) =>
        prev.map((r) => (r.id === id ? form : r))
      );
    } else {
      const docRef = await addDoc(collection(db, "bolao"), form);
      const updatedForm = { ...form, id: docRef.id };
      setForm(updatedForm);
      alert("Registro criado.");
      setRegistros((prev) => [...prev, updatedForm]);
    }
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "bolao", id));
    setRegistros((prev) => prev.filter((r) => r.id !== id));
    setSelecionado(null);
    alert("Registro excluído.");
  };

  const toggleAccordion = (accordion) => {
    setActiveAccordion(activeAccordion === accordion ? null : accordion);
  };

  if (!isAdmin)
    return (
      <div className="p-6 text-red-600">
        Acesso restrito ao administrador.
      </div>
    );

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8 flex flex-col sm:flex-row gap-6">
        <aside className="sm:w-1/3 bg-white shadow-md border-r rounded p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Jogos cadastrados
            </h2>
            <button
              onClick={() => {
                const novo = {
                  tipo: "",
                  concurso: "",
                  data: "",
                  premio: "",
                  totalCotas: "",
                  valorCota: "",
                  participantes: [],
                  numerosSorteados: [],
                  apostas: [{ numerosAposta: [], valorAposta: 0 }], // Inicializa com uma aposta vazia
                };
                setForm(novo);
                setSelecionado(null);
              }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded transition-colors duration-200"
            >
              Novo Registro
            </button>
          </div>
          {registros.map((r) => (
            <div
              key={r.id}
              onClick={() => handleSelect(r)}
              className={`cursor-pointer mb-4 p-4 border rounded transition-colors duration-200 hover:bg-blue-50 ${
                r.id === selecionado
                  ? "bg-blue-100 border-blue-400"
                  : "bg-white border-gray-200"
              }`}
            >
              <div className="font-semibold text-lg">
                {r.tipo} #{r.concurso}
              </div>
              <div className="text-sm text-gray-600">{r.data}</div>
            </div>
          ))}
        </aside>

        <main className="sm:w-2/3 bg-white rounded shadow p-6">
          {form ? (
            <>
              <h2 className="text-2xl font-bold text-gray-800 mb-6">
                Detalhes do Jogo
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                {["tipo", "concurso", "data", "premio", "totalCotas", "valorCota"].map(
                  (field) => (
                    <div key={field}>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        {field === "totalCotas"
                          ? "Total de Cotas"
                          : field === "valorCota"
                          ? "Valor da Cota"
                          : field}
                      </label>
                      <input
                        type={
                          field === "totalCotas" || field === "valorCota"
                            ? "number"
                            : "text"
                        }
                        value={form[field]}
                        onChange={(e) =>
                          handleChange(
                            field,
                            field === "totalCotas" || field === "valorCota"
                              ? Number(e.target.value)
                              : e.target.value
                          )
                        }
                        className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  )
                )}
              </div>

              <div className="mt-6">
                <div className="border border-gray-300 rounded">
                  <button
                    className="w-full p-4 text-left font-medium text-gray-700 hover:bg-gray-100"
                    onClick={() => toggleAccordion("participantes")}
                  >
                    Participantes
                    <span className="float-right">
                      {activeAccordion === "participantes" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </span>
                  </button>
                  {activeAccordion === "participantes" && (
                    <div className="p-4 border-t border-gray-300">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-xl font-semibold text-gray-800">
                          Participantes
                        </h3>
                        <button
                          onClick={handleAddParticipant}
                          className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded transition-colors duration-200"
                        >
                          Adicionar Participante
                        </button>
                      </div>

                      {form.participantes?.map((p, idx) => (
                        <div
                          key={idx}
                          className="bg-gray-50 p-4 mb-4 rounded shadow relative"
                        >
                          <div className="absolute top-2 right-2">
                            <button
                              onClick={() => handleRemoveParticipant(idx)}
                              className="bg-red-500 hover:bg-red-600 text-white text-xs px-2 py-1 rounded"
                            >
                              Excluir
                            </button>
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Nome
                              </label>
                              <input
                                type="text"
                                value={p.nome}
                                onChange={(e) =>
                                  handleParticipantChange(idx, "nome", e.target.value)
                                }
                                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Cotas
                              </label>
                              <input
                                type="number"
                                value={p.cotas}
                                onChange={(e) =>
                                  handleParticipantChange(idx, "cotas", Number(e.target.value))
                                }
                                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>
                          <div className="mt-4">
                            {p.comprovanteUrl && (
                              <a
                                href={p.comprovanteUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline text-sm"
                              >
                                Ver comprovante
                              </a>
                            )}
                            <input
                              type="file"
                              accept="image/*,application/pdf"
                              className="mt-2 block text-sm"
                              onChange={(e) =>
                                handleComprovanteUpload(idx, e.target.files[0])
                              }
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Acordeão para Apostas */}
                <div className="border border-gray-300 rounded mt-4">
                  <button
                    className="w-full p-4 text-left font-medium text-gray-700 hover:bg-gray-100"
                    onClick={() => toggleAccordion("apostas")}
                  >
                    Apostas
                    <span className="float-right">
                      {activeAccordion === "apostas" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </span>
                  </button>
                  {activeAccordion === "apostas" && (
                    <div className="p-4 border-t border-gray-300">
                      <div className="flex items-center justify-between mb-4">
                        <h3 className="text-xl font-semibold text-gray-800">
                          Apostas
                        </h3>
                        <button
                          onClick={handleAddAposta}
                          className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded transition-colors duration-200"
                        >
                          Adicionar Aposta
                        </button>
                      </div>

                      {form.apostas?.map((aposta, apostaIdx) => (
                        <div
                          key={apostaIdx}
                          className="bg-gray-50 p-4 mb-4 rounded shadow relative"
                        >
                          <div className="absolute top-2 right-2">
                            <button
                              onClick={() => handleRemoveAposta(apostaIdx)}
                              className="bg-red-500 hover:bg-red-600 text-white text-xs px-2 py-1 rounded"
                            >
                              Excluir
                            </button>
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Números da Aposta (separados por vírgula ou espaço)
                              </label>
                              <input
                                type="text"
                                value={aposta.numerosAposta.join(", ")}
                                onChange={(e) =>
                                  handleApostaChange(apostaIdx, "numerosAposta", e.target.value)
                                }
                                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                Valor da Aposta
                              </label>
                              <input
                                type="number"
                                value={aposta.valorAposta}
                                onChange={(e) =>
                                  handleApostaChange(apostaIdx, "valorAposta", Number(e.target.value))
                                }
                                className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Acordeão para Números Sorteados */}
                <div className="border border-gray-300 rounded mt-4">
                  <button
                    className="w-full p-4 text-left font-medium text-gray-700 hover:bg-gray-100"
                    onClick={() => toggleAccordion("numerosSorteados")}
                  >
                    Números Sorteados
                    <span className="float-right">
                      {activeAccordion === "numerosSorteados" ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </span>
                  </button>
                  {activeAccordion === "numerosSorteados" && (
                    <div className="p-4 border-t border-gray-300">
                      <div className="flex flex-wrap gap-2">
                        {form.numerosSorteados?.map((numero, idx) => (
                          <div key={idx} className="flex items-center gap-2">
                            <input
                              type="number"
                              value={numero}
                              onChange={(e) => {
                                const updated = [...form.numerosSorteados];
                                updated[idx] = Number(e.target.value);
                                setForm((prev) => ({ ...prev, numerosSorteados: updated }));
                              }}
                              className="w-16 p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                              onClick={() => {
                                const updated = [...form.numerosSorteados];
                                updated.splice(idx, 1);
                                setForm((prev) => ({ ...prev, numerosSorteados: updated }));
                              }}
                              className="bg-red-500 hover:bg-red-600 text-white text-xs px-2 py-1 rounded"
                            >
                              Excluir
                            </button>
                          </div>
                        ))}
                        <button
                          onClick={() => {
                            setForm((prev) => ({
                              ...prev,
                              numerosSorteados: [...prev.numerosSorteados, 0],
                            }));
                          }}
                          className="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded transition-colors duration-200"
                        >
                          Adicionar Número
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex flex-wrap gap-4 mt-6">
                <button
                  onClick={handleSave}
                  className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded shadow transition-colors duration-200"
                >
                  Salvar
                </button>
                {form.id && (
                  <button
                    onClick={() => handleDelete(form.id)}
                    className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded shadow transition-colors duration-200"
                  >
                    Excluir
                  </button>
                )}
              </div>
            </>
          ) : (
            <div className="text-gray-500 text-lg">
              Selecione um jogo à esquerda
            </div>
          )}
        </main>
      </div>
    </div>
  );
}